var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"moow-input-single",class:_vm.getClasses(),attrs:{"id":_vm.id,"cols":_vm.cols,"rows":_vm.rows,"placeholder":_vm.placeholder,"autocomplete":{'on': _vm.autocomplete, 'off': !_vm.autocomplete},"inputType":_vm.inputType},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0a173c2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/interface/input/moowInputSingle.vue
// module id = null
// module chunks = 